export default "__VITE_ASSET__BhSA99oR__"